<template>
  <div class="forIsrael">
    {{ msg }}
  </div>
</template>

<script>
export default {
  data() {
    return {
      msg: "",
    };
  },
  methods: {
    getChannel() {
      let args = {};

      const qs =
        window.location.search.length > 0
          ? window.location.search.substr(1)
          : "";

      const itemsArray = qs.length > 0 ? qs.split("&") : [];

      itemsArray.forEach((e) => {
        let item = e.split("=");
        let name = decodeURIComponent(item[0]);
        let value = decodeURIComponent(item[1]);

        if (name.length !== 0) {
          args[name] = value;

          if (name == "message") {
            this.msg = value;
          }
        }
        return args;
      });
    },
  },
  mounted() {
    this.getChannel();
  },
};
</script>

<style lang="scss">
.forIsrael {
  width: 100vw;
  height: 70vh;
  margin: 0 auto;
  text-align: center;
  background: #fff;
  padding-top: 30vh;
  font-size: 4rem;
}
</style>



// WEBPACK FOOTER //
// src/components/forIsrael/index.vue